import { AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { from, Subject } from 'rxjs';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService } from '../../api.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, AfterViewInit {

  selectedValuation: number = 1;
  isSelectedStanderd: boolean = true;
  isSelectedHistorical: boolean = false;
  isSelectedLPP: boolean = false;
  oldValuation: string = "";
  configData: any = [];
  agencyData: any = [];
  jarvisData: any = []; 
  isIndian: boolean = false;
  
  stgFlowList: any = [];
  stgFlowName: string = "";
  originalStageList: any = [];
  stgFlowDataBeforeUpdate: any = [];
  stageList: any = [];
  newStageList: any = [];
  stageName: string = "";
  stgActionType: number = 1;
  isAdd: boolean = true;
  stgFlowActionType: string = "";
  prntCnfgMdlRef: any;
  @ViewChild('prntCnfgMdl', { static: false }) prntCnfgMdl!: ElementRef;
  @ViewChild('mymodal') valuationModalRef!: TemplateRef<any>;
  prtCnfg: { rates: boolean, totalPrice: boolean} = {
    rates: false,
    totalPrice: false
  }
  rights: any;

  changingValue: Subject<boolean> = new Subject();
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.newStageList, event.previousIndex, event.currentIndex);
    for(let j = 0; j < this.newStageList.length; j++){
      this.newStageList[j].Seq = j + 1;
    }
  }
  constructor(private modalService: NgbModal,private router: Router,private apiService: APIService, private http: HttpClient, private spinnerService: NgxSpinnerService, private route: ActivatedRoute) { }
  ngOnInit(): void {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      if(this.agencyData.length > 0){
        this.isIndian = this.agencyData[0].CC == 91 ? true : false;
      }
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let erpCfgCookie = this.apiService.getCookie('ERP_Cfg');
    if(erpCfgCookie) {
      let parsedCfgCookie = JSON.parse(erpCfgCookie);
      if(parsedCfgCookie && parsedCfgCookie.length > 0) {
        this.originalStageList = JSON.parse(parsedCfgCookie[0].PrdJobStages)
        this.stageList = this.originalStageList;
        if(parsedCfgCookie[0].BOMPrtCfg) {
          let prtCnfg = JSON.parse(parsedCfgCookie[0].BOMPrtCfg);
          if(prtCnfg && prtCnfg.length > 0) {
            this.prtCnfg.rates = prtCnfg[0].rates ? prtCnfg[0].rates : false;
            this.prtCnfg.totalPrice = prtCnfg[0].totalPrice ? prtCnfg[0].totalPrice : false;
          }
        }
      }
    }

    this.rights = this.apiService.getCookie("J");
    if(this.rights){
      this.rights = JSON.parse(this.rights);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.rights = $.grep(this.rights, function(o: any){ return o.UserID == ownUserID })[0];
    }

    let valMethodCookie = this.apiService.getCookie("ValMethod");
    if(valMethodCookie) {
      let parsedvalMethodCookie = JSON.parse(valMethodCookie);
      if(parsedvalMethodCookie && parsedvalMethodCookie.length > 0) {
        let valMethoNo = parsedvalMethodCookie[0].ValnMethod;
        this.findValMethod(valMethoNo);
      }
    }

    let stgFlwCookie = this.apiService.getCookie("StgFlw");
    if(stgFlwCookie) {
      let parsedStgFlwCookie = JSON.parse(stgFlwCookie);
      if(parsedStgFlwCookie && parsedStgFlwCookie.length > 0) {
        this.stgFlowList = parsedStgFlwCookie;
      }
    }

    if((!valMethodCookie && !stgFlwCookie) || (!stgFlwCookie)) {
      this.getValMethod("STGFLW");
    }
    else if(!valMethodCookie){
      this.getValMethod("");
    }

  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['v'] == '1') {
        setTimeout(() => {
          this.open(this.valuationModalRef, '');
        }, 100);
      }

      if (params['bom'] == '1') {
        setTimeout(() => {
          this.openPrntCnfgMdl('prntCnfgMdl');
        }, 120);
      }
    });
  }

   // getUnits() - get all units from database
   getValMethod(callType: string = "") {
    var tempData = [{
      'changeType': 'STAGEFLOW',
    }];
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: callType == "STGFLW" ? JSON.stringify(tempData) : ""
    }];
    this.spinnerService.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }
  
    //successResp - success  get handler
    successResp(res: any) {
      this.spinnerService.hide();  
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
                  let valMethoNo = JSON.parse(reponseData.Table2[0].ValnMethod);
                  this.apiService.setCookie("ValMethod", valMethoNo);
                  this.findValMethod(valMethoNo);
              }
              if (reponseData.Table4) {
                this.apiService.setCookie("StgFlw", JSON.stringify(reponseData.Table4));
                this.stgFlowList = reponseData.Table4;
            }
          }
      }
    }

  //failureResp - failure handler
  failureResp(res: any) {
    this.spinnerService.hide();
    if (res.error) {
    }
  }

  findValMethod(no: number){
    if(no == 1){
        this.oldValuation = "Standard Cost"
        this.isSelectedStanderd = true;
        this.isSelectedHistorical = false;
        this.isSelectedLPP = false
        //this.selectedValuation = 1;
    }
    else if(no == 2){
        this.oldValuation = "Last Purchase Price"
        this.isSelectedHistorical = false;
        this.isSelectedStanderd = false;
        this.isSelectedLPP = true
        //this.selectedValuation = 2;
    }
    else if(no == 3){
        this.oldValuation = "Historical Average"
        this.isSelectedLPP = false
        this.isSelectedHistorical = true;
        this.isSelectedStanderd = false;
        //this.selectedValuation = 3;
    }
    else{
        this.oldValuation = "Standard Cost"
        this.oldValuation = "Standard Cost"
        this.isSelectedStanderd = true;
        this.isSelectedHistorical = false;
        this.isSelectedLPP = false
    }
  }

  closeResult: any;
  modalReference: any;
  modalStage: any;

  // open() - open edit unit and add new unit modal 
  open(content: any, mdlType: string) { 
    let wndwCls = "ValuationModal";
    if (mdlType == "stageFlow") {
      wndwCls = 'stageFlowMdl';
    }
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: wndwCls, backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
      },
          (reason: any) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  // open() - open edit unit and add new unit modal 
  openAddStageFlow(content: any) { 
    this.resetStageFlow();
    this.modalStage = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'stageFlowMdl', backdrop: 'static', keyboard: false });
      this.modalStage.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
      },
          (reason: any) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
      this.stgActionType = 2;
  }

  private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
      } else {
          return `with: ${reason}`;
      }
  }

  public closeModal($event: any) {
    this.stgActionType = 1;
    this.resetStageFlow();
      this.modalReference.close();
      if ($event) {
          this.changingValue.next($event);
      }
  }


  // redirect() - redirect to config 
  redirect(id: any){
    if(id == 1){
      this.router.navigate(['Stores']);
    }
    else if(id == 2){
      this.router.navigate(['Categories']);
    }
    else if(id == 3){
      this.router.navigate(['Units']);
    }
    else if(id == 4){
      //this.router.navigate(['Valuation']);
      
    }
    else if(id == 5){
      this.router.navigate(['HSNSAC']);    
    }
    else{
      this.router.navigate(['Stores']);
    }
  }

  selectValuation(id: number, name: string ){
    if(confirm("Are you sure you wish to change your inventory valuation method " + this.oldValuation + " to " + name + "?")) {
      if(id == 1){
        this.isSelectedStanderd = true;
        this.isSelectedHistorical = false;
        this.isSelectedLPP = false
        this.selectedValuation = 1;
      }
      else if(id == 2){
        this.isSelectedHistorical = false;
        this.isSelectedStanderd = false;
        this.isSelectedLPP = true
        this.selectedValuation = 2;
      }
      else{
        this.isSelectedLPP = false
        this.isSelectedHistorical = true;
        this.isSelectedStanderd = false;
        this.selectedValuation = 3;
      }
      this.save()
    }
  }


    // save final data
    save(){
      var tempData = [{
        'ChangeType': 'VALN',
        'GSTLdgrs':'',
        'Units': '',
        'Stores':'',
        'ItemCategories': '',
        'PrdJobStages': '',
        'ValnMethod': this.selectedValuation,
        'PrdRejnReasons': '',
        'HSNSAC':'',
    }]
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'set',
        moduleID: 6,
        data: JSON.stringify(tempData)
    }];
    this.spinnerService.show();
    this.apiService.sendChange(myParams, this.successEdit.bind(this), this.failureResponse.bind(this));
    }
  
     //successVchrEntry - success voucher entry handler
     successEdit(res: any) {
      this.spinnerService.hide();
      if (res.error) {
      }
      else {
        if (res) {
          var ErpData = JSON.parse(res.updatePackage);
            if (ErpData.Table1) {
              let coockieData = [];
              coockieData.push(ErpData.Table1[0]);
              let ErpAgn = JSON.stringify(coockieData);
              localStorage.setItem("ERP_Agn", ErpAgn)
            }
            if (ErpData.Table2) {
              let cookieData2 = [];
              cookieData2.push(ErpData.Table2[0]);
              let ErpCfgData = JSON.stringify(cookieData2);
              localStorage.setItem("ERP_Cfg", ErpCfgData)
            }
      }
          this.getValMethod("");      
          this.modalReference.close();
      }
  }
  
  //failureResp - failure handler
  failureResponse(res: any) {
    this.spinnerService.hide();
    if (res.error) {
    }
  }

  backToInvtr(){
    history.back()
  }

  backBtn() {
    window.history.back();
  }

  // addNewStage - add new stage
  addNewStage(event: Event){
    let selectElement = event.target as HTMLSelectElement;
    this.stageName = selectElement.value;
    
    if(!this.stageName){
      return;
    }

    let tempStageList = this.stageList;
    let tempStage = tempStageList.filter((element: any, index: any) => {
      return (element.SNm == this.stageName);
    });

    if (tempStage.length == 0) {
      return;
    }

    this.stageList = this.stageList.filter((element: any) => element.SNm !== this.stageName);
    
    this.newStageList.push({
      SID: tempStage[0].SID,
      SNm: tempStage[0].SNm,
      UIDs: tempStage[0].UIDs,
      TID: tempStage[0].TID
    });

    this.stageName = "";
  }

  // removeStage - remove stage
  removeStage(ind: any){
    if(ind < 0){
      return;
    }

    let removedStage = this.newStageList.splice(ind, 1)[0];

    let tempStage = this.originalStageList.filter((element: any, index: any) => {
      return (element.SID == removedStage.SID);
    });

    if(tempStage.length == 0){
      return;
    }

    this.stageList.push(tempStage[0]);
    this.stageName = "";
  }

  // changeStgActionType - change stage action type
  changeStgActionType (id: number){
    if(id == 1 || id == 2){
      this.stgActionType = id;
      this.isAdd = true;
      this.resetStageFlow();
    }
  }

  // saveStageFlow - save stage flow
  saveStageFlow () {
    this.stgFlowName = this.stgFlowName.trim(); 
    let isDuplicate = false;
    if (!this.stgFlowName) {
      this.apiService.successAlert("Please enter stage flow name.");
      return;
    }

    isDuplicate = this.stgFlowList.some(
      (element: any) => element.StageFlow.toUpperCase() === this.stgFlowName.toUpperCase() &&
      (this.isAdd || element.StageFlowID !== this.stgFlowDataBeforeUpdate.StageFlowID)
    );


    if (isDuplicate) {
      this.apiService.successAlert("Stage flow name already exists.");
      return;
    }


    if (this.newStageList.length == 0) {
      this.apiService.successAlert("Please add stages to stage flow.");
      return;
    }
    
    this.newStageList.forEach((obj: any, index: any) => {
      obj.Seq = index + 1; // Assign sequence starting from 1
    });
    this.saveStageFlowDataToDB(this.stgFlowName, this.newStageList, this.isAdd ? "ADD" : "UPDATE");

  }

  // saveStageFlowDataToDB - save stage flow data to database
  saveStageFlowDataToDB(stageFlowName: string, stageFlowData: any,stgFlowActionType: string) {
    this.stgFlowActionType = stgFlowActionType
    let stgFlwChngType = "";

    switch (this.stgFlowActionType) {
      case "ADD":
      stgFlwChngType = "STAGEFLOWADD";
      break;
      case "UPDATE":
      stgFlwChngType = "STAGEFLOWUPDT";
      break;
      case "DELETE":
      stgFlwChngType = "STAGEFLOWDLT";
      break;
      default:
      this.apiService.successAlert("Invalid action type.");
      return;
    }

    
    let myLastSyncDT = localStorage.getItem("MyLastSyncDT");
    var tempData = [{
      'ChangeType': stgFlwChngType,
      'GSTLdgrs':'',
      'Units': '',
      'Stores':'',
      'ItemCategories': '',
      'PrdJobStages': '',
      'ValnMethod': 0,
      'PrdRejnReasons': '',
      'stgFlowID': this.stgFlowDataBeforeUpdate.StageFlowID ? this.stgFlowDataBeforeUpdate.StageFlowID : 0,
      'stgFlowName': stageFlowName,
      'stgFlowData': JSON.stringify(stageFlowData),
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: myLastSyncDT,
        isWeb: true,
        actionType: 'set',
        moduleID: 6,
        data: JSON.stringify(tempData)
    }];
    this.spinnerService.show();
    this.apiService.sendChange(myParams, this.successStageEntry.bind(this), this.failureStageResp.bind(this));
  }

  

  // failureResp - failure handler
  failureStageResp(res: any) {
    this.spinnerService.hide();
    if (!res.error) {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successStageEntry(res: any) {
    this.spinnerService.hide();
    if (!res.error) {
        if (!res) {
          return;
        }
        var reponseData = JSON.parse(res.updatePackage);
        if(reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let succErrMsg = "";
          if (this.stgFlowActionType == "ADD") {
            succErrMsg = "added";
          }
          else if (this.stgFlowActionType == "UPDATE") {
            succErrMsg = "updated";
          }
          else if (this.stgFlowActionType == "DELETE") {
            succErrMsg = "deleted";
          }

          this.apiService.successAlert("Stage flow " + succErrMsg + ".");
          if(this.modalStage) {
            this.modalStage.close('Done');
            this.resetStageFlow();
            this.stgActionType = 1
            this.getValMethod("STGFLW");
          }
        }
    }
  }

  // removeStageFlow - remove stage flow
  removeStageFlow(ind: any){
    var r = confirm("Are you sure you want to delete this StageFlow?");
    if(r == false) {
      return;
    }
    this.stgFlowDataBeforeUpdate = this.stgFlowList[ind];
    this.saveStageFlowDataToDB(this.stgFlowList[ind].StageFlow, [], "DELETE");
  }

  // editStageFlow - edit stage flow
  editStageFlow(content: any, ind: any){
    this.stgFlowDataBeforeUpdate  = this.stgFlowList[ind];
    this.stgFlowName = this.stgFlowList[ind].StageFlow;
    this.newStageList = JSON.parse(this.stgFlowList[ind].Stages);
    this.stageList = this.originalStageList.filter( (originalStage:any) => 
      !this.newStageList.some( (newStage:any) => newStage.SID === originalStage.SID)
    );
    // this.stgActionType = 2;
    this.isAdd = false;

    this.modalStage = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'stageFlowMdl', backdrop: 'static', keyboard: false });
  }

  // resetStageFlow - reset stage flow
  resetStageFlow() {
    this.stgFlowName = "";
    this.stageList = this.originalStageList;
    this.newStageList = [];
  }

  closeStageModal() {
    this.modalStage.close();
  }
  openPrntCnfgMdl(content: any) {
    if(this.prntCnfgMdl){
      const content = this.prntCnfgMdl.nativeElement;
      this.prntCnfgMdlRef = this.modalService.open(this.prntCnfgMdl, {ariaLabelledBy: 'tsk-done-modal', backdrop: 'static', keyboard: false, windowClass: 'taskDoneModal' });
      this.prntCnfgMdlRef.componentInstance.content = content;
    }
  }

  closePrntCnfModal() {
    this.prntCnfgMdlRef.close();
  }
  savePrntCnfg(){
    let temp = [];
    temp.push(this.prtCnfg);
    var tempData = [{
        'ChangeType': 'BOMPRTCFG',
        'GSTLdgrs':'',
        'Units': '',
        'Stores':'',
        'ItemCategories': '',
        'PrdJobStages': '',
        'ValnMethod': 0,
        'PrdRejnReasons': '',
        'stgFlowID': 0,
        'stgFlowName': '',
        'stgFlowData': '',
        'PrtCfg': '',
        'BOMPrtCfg': JSON.stringify(temp)
    }]
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'set',
        moduleID: 6,
        data: JSON.stringify(tempData)
    }];
	  this.spinnerService.show();
    this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
  }

  successEntry(res: any) {
	  this.spinnerService.hide();
    if (res.error) {
      this.apiService.successAlert(res.error);
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
        if (ErpData.Table2) {
          let cookieData2 = [];
          cookieData2.push(ErpData.Table2[0]);
          let ErpCfgData = JSON.stringify(cookieData2);
          localStorage.setItem("ERP_Cfg", ErpCfgData);
          this.apiService.successAlert("BOM print configuration saved successfully.");
        }
      }   
      this.prntCnfgMdlRef.close();
    }
  }
}
